import type { LocationCreateSchema } from '@repo/schemas/location/locationCreate';
import type { LocationEditSchema } from '@repo/schemas/location/locationEdit';
import type { LocationPublic } from '@repo/types/locations';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '#api-client';

export class LocationService {
  static async getLocation(id?: number): Promise<AxiosResponse<LocationPublic>> {
    return await axiosInstance.get(`/api/location/${id}`);
  }

  static async getLocations(): Promise<AxiosResponse<Array<LocationPublic>>> {
    return await axiosInstance.get('/api/location/all');
  }

  static async postLocation(data: LocationCreateSchema): Promise<AxiosResponse<LocationPublic>> {
    return await axiosInstance.post('/api/location', data);
  }

  static async editLocation(data: LocationEditSchema): Promise<AxiosResponse<LocationPublic>> {
    const { id, ...rest } = data;
    return await axiosInstance.put(`/api/location/${id}`, rest);
  }

  static async deleteLocation(id: number): Promise<AxiosResponse<string>> {
    return await axiosInstance.delete(`/api/location/${id}`);
  }
}
